module.exports = __webpack_public_path__ + "static/media/zobu.3f85bfeb.svg";